/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getCWPPlot = (params) => makeApiCall(`/cwp_query`, 'GET', params);
export const getDCR = (params) => makeApiCall(`/dcr_query`, 'GET', params);
export const getPresentationLog = (params) =>
  makeApiCall(`/dcr/agendas/marketing_materials`, 'GET', params);
export const getPurchaseOrderReport = (params) =>
  makeApiCall(`/hospitals/po/report`, 'GET', params);
